<div class="ion-page" style="overflow-y: hidden !important ;">
  <ion-header>
    <ion-toolbar style="text-align: center;" color="secondary">
      <ion-title>{{isAddOwner ? ('Add owner to ' | translate): ('Add user to ' | translate)}} {{group?.Name}}</ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content color="secondary" style=" height: 82% !important;">
    <ion-searchbar class="search" placeholder="{{'Search for users name, email' | translate}}" (ionInput)="onSearch($event)"></ion-searchbar>

    <ion-button (click)="openUserModal()" color="medium" expand="block" style="width: 60%; margin-left: 20%;" class="btn">
      <ion-icon name="add"></ion-icon>
      {{' New user' | translate}}
    </ion-button>
    <br>
      @if (users === undefined) {
        <ion-item color="secondary">
          <div> {{'There is an error ...' | translate}}</div>
        </ion-item>
      }
      <ion-list style="padding: 0 !important;background-color: var(--ion-color-secondary);">
        @for (user of filteredUsers; track user) {
          <ion-item color="secondary" [button]="true" (click)="giveAccess(user)" lines="none">
            <ion-label>
              <h2>{{user.FirstName + ' ' + user.LastName}}</h2>
              <p class="email"><ion-icon name="mail-outline"></ion-icon> {{user.Email ? user.Email : 'n/a'}}</p>
            </ion-label>
            <ion-badge style="margin-right: 10px;" color="primary">{{ 'Select' | translate }}</ion-badge>
          </ion-item>
        }
      </ion-list>
      @if (filteredUsers?.length === 0) {
        <ion-item color="secondary">
          <div> {{'All existing users have been granted access to ' | translate}} {{group?.Name}}</div>
        </ion-item>
      }


      <!-- <ion-grid>
      <ion-row>
        <ion-col size="12">
          <ion-button color="tertiary" expand="block" style="max-width: 60%; margin-left: 20%;" (click)="onBack()" translate>Cancel</ion-button>
        </ion-col>
      </ion-row>
    </ion-grid> -->
  </ion-content>
  <ion-footer style="margin-top: auto; position: sticky; bottom: 0; z-index: 10; box-shadow: none; background-color: var(--ion-color-secondary);">
    <ion-toolbar style="--background: var(--ion-color-baseline-menu);">
      <ion-button color="tertiary" expand="block" style="max-width: 60%; margin-left: 20%;" (click)="onBack()">{{ 'Cancel' | translate }}</ion-button>
    </ion-toolbar>
  </ion-footer>
</div>
